export {
  default as ballMachine,
  ReactComponent as BallMachine,
} from '@assets/icons/features-and-amenities/ball-machine.svg'    
